module.exports = __webpack_public_path__ + "static/media/cevat.777b0d8b.jpg";